export default function DebugIcon({ color = "#79778E" }) {
  return (

    <svg width="2.4rem" height="2.4rem" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1 12C1 12 5 5 12 5C19 5 23 12 23 12C23 12 19 19 12 19C5 19 1 12 1 12Z" stroke={color} stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M11.21 9.12C9.94 9.46 9 10.62 9 12C9 13.66 10.34 15 12 15C13.66 15 15 13.66 15 12C15 11.61 14.92 11.23 14.78 10.89" stroke={color} stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
    </svg>

  )
}